/**
 * Queue Add Knowledge using unified /api/knowledge/jobs.
 * @param {object} api - api service
 * @param {{ scopeType?: string, id: string, extractMode?: string, extractEntities?: boolean }} anchor
 * @param {object[]} sources
 */

const VALID_EXTRACT_MODES = new Set(["auto", "force_on", "force_off"]);

export function resolveExtractMode(anchor) {
  const mode = anchor?.extractMode;
  if (mode && VALID_EXTRACT_MODES.has(String(mode))) {
    return String(mode);
  }
  if (anchor?.extractEntities === true) {
    return "force_on";
  }
  return "auto";
}

export async function queueAddKnowledgeJob(api, anchor, sources) {
  const scopeType = anchor?.scopeType || "entity";
  // Content-first: backend creates/reuses the anchor entity from content.
  if (scopeType === "content") {
    return api.queueKnowledgeJob("content", "", sources, {
      extractMode: "force_on",
    });
  }
  const anchorId = String(anchor?.id || "").trim();
  if (!anchorId) {
    throw new Error("Select where this knowledge belongs before submitting.");
  }
  const extractMode = resolveExtractMode(anchor);
  return api.queueKnowledgeJob(scopeType, anchorId, sources, {
    extractMode,
    ...(anchor?.extractEntities != null
      ? { extractEntities: Boolean(anchor.extractEntities) }
      : {}),
  });
}

function formatDocClass(response) {
  const docClass = response?.doc_class;
  if (!docClass) return "";
  return " (" + String(docClass).replace(/_/g, " ") + ")";
}

export function addKnowledgeSuccessMessage(anchor, response) {
  const name = anchor?.name || response?.job_display_name || "Knowledge";
  const reason =
    response?.classification_reason ||
    response?.extract_decision_reason ||
    "";
  const reasonSuffix = reason ? (" " + reason) : "";
  const docSuffix = formatDocClass(response);

  if (response?.extract_entities) {
    return (
      "Architecture extraction queued for " + name + docSuffix + "." + reasonSuffix + " Open Insights Inbox when review is ready."
    ).trim();
  }
  if (anchor?.scopeType === "knowledge_surface") {
    return (
      "Knowledge added to " + name + docSuffix + ". It is indexed and available for search."
    ).trim();
  }
  return (
    "Indexing queued for " + name + docSuffix + ". No entity extraction will run." + reasonSuffix + " Inbox will confirm when it finishes."
  ).trim();
}

export function addKnowledgeQueueLabel(anchor) {
  const mode = resolveExtractMode(anchor);
  if (mode === "force_on") {
    return "Queuing architecture extraction...";
  }
  if (mode === "force_off") {
    return "Indexing knowledge for search...";
  }
  return "Queuing knowledge ingestion...";
}
